import { render, staticRenderFns } from "./BetgameFinished.vue?vue&type=template&id=08af8f92"
import script from "./BetgameFinished.vue?vue&type=script&lang=js"
export * from "./BetgameFinished.vue?vue&type=script&lang=js"
import style0 from "./BetgameFinished.vue?vue&type=style&index=0&id=08af8f92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports